import axios from "axios";
import interceptors from "@/shared/api/interceptors";
window.domain = window.__CONFIG__.VUE_APP_BASE_DOMAIN;

const apiClient3 = axios.create({
  baseURL: window.domain + "/dt",
  withCredentials: true,
});

interceptors(apiClient3);

export default apiClient3;
